import { createSlice } from "@reduxjs/toolkit";
import { fetchAdminMetrics } from "../../thunks/admin/fetchAdminMetrics";

const adminMetricsSlice = createSlice({
  name: "adminMetrics",
  initialState: {
    data: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminMetrics.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAdminMetrics.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(fetchAdminMetrics.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default adminMetricsSlice.reducer;
